import { memo, useState } from 'react';

import { useAppConfig } from '@Contexts/AppConfig';
import OrderBonuses from '@Components/OrderBonuses';
import useOrderBonuses from '@Queries/useOrderBonuses';
import useTranslation from '@Queries/useTranslation';
import Placeholder from './elements/Placeholder/Placeholder';

import type { FC, HTMLAttributes } from 'react';
import type { AdditionalData, ModuleData } from '@Queries/useOrderBonuses';

export interface AsyncOrderBonusesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  productIds?: number[];
  isSetConfigurator?: boolean;
  isConstructor?: boolean;
  additional?: AdditionalData[];
  module?: ModuleData[];
}

const AsyncOrderBonuses: FC<AsyncOrderBonusesProps> = (props) => {
  const { productIds, isSetConfigurator, isConstructor, additional, module, ...restProps } = props;
  const { t } = useTranslation();
  const orderBonuses = useOrderBonuses({
    productIds,
    isSetConfigurator,
    isConstructor,
    opts: { additional, module },
  });
  const extra = orderBonuses.isSuccess && orderBonuses.data.needExtraIcon;
  const count = orderBonuses.isSuccess && orderBonuses.data.earnedAmount;
  const isMaxBonus = orderBonuses.isSuccess && orderBonuses.data.isMaxBonusAmount;
  const error = orderBonuses.isError ? t('ui.bonuses.count-error') : undefined;

  return (
    <OrderBonuses
      {...restProps}
      error={error}
      loading={orderBonuses.isPending || orderBonuses.isFetching}
      isMaxBonus={isMaxBonus}
      count={count}
      extra={extra}
    />
  );
};

const BonusesWrapper = (props) => {
  const { isProduction } = useAppConfig();
  const [isPlaceholder, setIsPlaceholder] = useState(true);
  const isPlaceholderVisible = !isProduction && isPlaceholder;

  return isPlaceholderVisible ? (
    <Placeholder showBouses={() => setIsPlaceholder(false)} />
  ) : (
    <AsyncOrderBonuses {...props} />
  );
};

export default memo(BonusesWrapper);
